import React, { Fragment, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import "./bannerform.scss";
import * as Yup from "yup";
import { Form, Formik, Field } from "formik";
import { connect } from "react-redux";
import { set_loading } from "../../../../redux/actions/LayoutAction";
import { apiJson } from "../../../../api/Api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClipLoader from "react-spinners/ClipLoader";
import { Redirect } from "react-router-dom";
import { FileUploadPromise } from "../../../../utils/aws_s3/aws_s3";
import { useParams } from "react-router-dom";
import DropzoneElement from "../../../../components/Dropzone/DropzoneElement";
import { getRandomItem, getClass } from "../../../../utils/utils";
import { type } from "../../../../components/Dropzone/type";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 0,
    minWidth: 120,
    width: 180,
    height: 40,
  },
  selectEmpty: {
    backgroundColor: "#F9F9F9",
    marginTop: 0,
    width: 170,
    height: 40,
  },
}));

const ShopBannerForm = (props) => {
  const param = useParams();
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [goToView, setGoToView] = useState(false);
  const [data, setData] = useState(false);
  const [goToUpdate, setGoToUpdate] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const bannerTypes = [
    { label: "Middle Banner", value: "middle_banner" },
  ];
  const [bannerType, setBannerType] = useState();

  const classes = useStyles();

  const { readOnly } = props;

  const bannerSchema = Yup.object().shape({
    banner_type: Yup.string().required("Required"),
    link: Yup.string().required("Required"),
    position: Yup.string().required("Required"),
    image: Yup.string().required("Required"),
  });

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const showSuccess = () => {
    toast.success(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  useEffect(() => {
    if (props.state === "view" || props.state === "update") {
      setData(true);
      apiJson.shop_banner.getBannerDetails(parseInt(param.id)).then((response) => {
        if (response.success) {
          setInitialValues(response.data);
          setBannerType({
            label: response.data.banner_type,
            value: response.data.banner_type,
          });
          setData(false);
        } else if (!response.status) {
          // eslint-disable-next-line
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
          setData(false);
        } else {
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
            setData(false);
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
    } else {
      setInitialValues({
        banner_type: "",
        link: "",
        position: "",
        image: "",
      });
    }
  }, []);

  const createBanner = (values) => {
    setLoading(true);
    apiJson.shop_banner
      .createBanner({
        shop_banner: values,
      })
      .then((response) => {
        if (response.success) {
          message = "Banner Created";
          showSuccess();
          setLoading(false);
          setRedirect(true);
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const editBanner = (values) => {
    setGoToView(false);
    setLoading(true);
    apiJson.shop_banner
      .updateBanner(param.id, {
        shop_banner: values,
      })
      .then((response) => {
        if (response.success) {
          message = "Banner Updated";
          showSuccess();
          setLoading(false);
          setRedirect(true);
        } else if (!response.status) {
          setLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
  };

  const deleteBanner = () => {
    setRedirect(false);
    if (window.confirm("Are you sure you want to delete this banner?")) {
      setDeleteLoading(true);
      apiJson.shop_banner.deleteBanner(param.id).then((response) => {
        if (response.success) {
          message = "Banner Deleted";
          showSuccess();
          setDeleteLoading(false);
          setRedirect(true);
        } else if (!response.status) {
          setDeleteLoading(false);
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        } else {
          setDeleteLoading(false);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      });
    }
  };

  const handleFileUpload = (files, setFieldValue) => {
    setImageLoading(true);

    const file = files[0];
    FileUploadPromise(file)
      .then((response) => {
        setFieldValue("image", response.location);
        setImageLoading(false);
      })
      .catch((err) => {
        setImageLoading(false);
        message = "File upload error";
        showError();
      });
  };
  const handleType = (val, setFieldValue) => {
    setFieldValue("banner_type", val.value);
    setBannerType(val);
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(data), [data]);
  return (
    <Fragment>
      <div className="banner-form-desktop">
        {!data && (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={bannerSchema}
              enableReinitialize
              onSubmit={(values) => {
                if (props.state === "update") {
                  editBanner(values);
                } else if (props.state === "create") {
                  createBanner(values);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                setFieldValue,
                setFieldTouched,
              }) => (
                <Form>
                  <div className="form-main row g-0">
                    <div className="row g-0">
                      <div className="left-group-buttons col-lg-6 col-md-12">
                        <div className="row g-0">
                          <div className="select-brand row">
                            <label className="brand-label all-text col-3 padding-for-all align-items-center">
                              Type
                            </label>
                            <div className="col-8 input">
                              <Select
                                isDisabled={props.readOnly}
                                name="banner_type"
                                value={bannerType}
                                onChange={(val) =>
                                  handleType(val, setFieldValue)
                                }
                                options={bannerTypes}
                                className={`category-select ${getClass(
                                  touched.banner_type && errors.banner_type
                                )}`}
                                onBlur={() =>
                                  setFieldTouched("banner_type", true)
                                }
                                classNamePrefix="control"
                              />
                              {touched.banner_type && errors.banner_type && (
                                <div
                                  className="error"
                                  style={{
                                    color: "red",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  {errors.banner_type}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="select-brand row">
                            <label className="brand-label all-text col-3 padding-for-all">
                              Redirect Link
                            </label>
                            <div className="col-8 input">
                              <div style={{ display: "flex" }}>
                                <span>https://alisuq.com/</span>
                                <Field
                                  disabled={props.readOnly}
                                  className={`w-100 ${getClass(
                                    touched.link &&
                                    errors.link
                                  )}`}
                                  name="link"
                                  type="text"
                                  placeholder=""
                                />
                              </div>
                              {touched.link &&
                                errors.link && (
                                  <div
                                    className="english-error"
                                    style={{
                                      color: "red",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    {errors.link}
                                  </div>
                                )}
                            </div>
                          </div>

                          <div className="select-brand row">
                            <label className="brand-label all-text col-3 padding-for-all">
                              Position
                            </label>
                            <div className="col-8 input">
                                <Field
                                  disabled={props.readOnly}
                                  className={`w-100 ${getClass(
                                    touched.position &&
                                    errors.position
                                  )}`}
                                  name="position"
                                  type="number"
                                  placeholder=""
                                />
                              {touched.position &&
                                errors.position && (
                                  <div
                                    className="english-error"
                                    style={{
                                      color: "red",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    {errors.position}
                                  </div>
                                )}
                            </div>
                          </div>

                          <div className="select-brand row height-100-px">
                            <label className="brand-label all-text col-3 padding-for-all">
                              Banner
                            </label>
                            <div className="col-8 input">
                              <FormControl
                                style={{ border: "0px" }}
                                className={`${classes.formControl} height-100-px`}
                              >
                                {imageLoading ? (
                                  <div className="d-flex justify-content-center align-items-center">
                                    <ClipLoader
                                      color="#000"
                                      loading
                                      size={35}
                                    />
                                  </div>
                                ) : (
                                  <>
                                    {values.image !== "" ? (
                                      <img
                                        src={values.image}
                                        width="100%"
                                        height="100%"
                                        alt=""
                                      />
                                    ) : (
                                      touched.image &&
                                      errors.image && (
                                        <div
                                          className="error"
                                          style={{
                                            color: "red",
                                            fontSize: "0.9rem",
                                          }}
                                        >
                                          {errors.image}
                                        </div>
                                      )
                                    )}
                                  </>
                                )}
                              </FormControl>
                            </div>
                          </div>

                          {!readOnly && (
                            <div className="select-brand col-lg-12 col-md-12">
                              <label className="brand-label all-text col-3 padding-for-all">
                                &nbsp;
                              </label>
                              <div className="col-8">
                                <DropzoneElement
                                  type={type.IMAGE}
                                  value="Click to select file"
                                  updateSelectedServiceFiles={(files) =>
                                    handleFileUpload(files, setFieldValue)
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row main-row g-0 d-flex flex-direction-md-revert-row">
                      <div className="right-bottom mx-auto">
                        <div className="d-flex justify-content-start">
                          {props.state === "create" ? (
                            <>
                              <div className="save-btn-div">
                                <button
                                  className="save-btn d-flex justify-content-center align-items-center"
                                  type="submit"
                                  key={getRandomItem(1, 1000)}
                                  disabled={loading}
                                >
                                  {loading ? (
                                    <ClipLoader
                                      color="#fff"
                                      loading
                                      size={20}
                                    />
                                  ) : (
                                    "Save"
                                  )}
                                </button>
                              </div>
                              <div className="cancel-btn-div">
                                <button
                                  className="cancel-btn d-flex justify-content-center align-items-center"
                                  type="button"
                                  onClick={() => setRedirect(true)}
                                >
                                  Cancel
                                </button>
                              </div>
                            </>
                          ) : props.state === "view" ? (
                            <>
                              <div className="save-btn-div">
                                <button
                                  className="save-btn d-flex justify-content-center align-items-center"
                                  type="button"
                                  onClick={() => setGoToUpdate(true)}
                                >
                                  Edit
                                </button>
                              </div>
                              <div className="delete-btn-div">
                                <button
                                  className="delete-btn d-flex justify-content-center align-items-center"
                                  type="button"
                                  onClick={() =>
                                    deleteBanner(props.bannerDetails.id)
                                  }
                                  disabled={deleteLoading}
                                >
                                  {deleteLoading ? (
                                    <ClipLoader
                                      color="#000"
                                      loading
                                      size={20}
                                    />
                                  ) : (
                                    "Delete"
                                  )}
                                </button>
                              </div>
                            </>
                          ) : (
                            props.state === "update" && (
                              <>
                                <div className="save-btn-div">
                                  <button
                                    className="save-btn d-flex justify-content-center align-items-center"
                                    type="submit"
                                    key={getRandomItem(1, 1000)}
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <ClipLoader color="#fff" size={20} />
                                    ) : (
                                      "Update"
                                    )}
                                  </button>
                                </div>
                                <div className="cancel-btn-div">
                                  <button
                                    className="cancel-btn d-flex justify-content-center align-items-center"
                                    type="button"
                                    onClick={() => setGoToView(true)}
                                  >
                                    Cancle
                                  </button>
                                </div>
                              </>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        )}
      </div>
      {goToUpdate && <Redirect push to={`/vendor/shop-banner/update/${param.id}`} />}
      {goToView && <Redirect push to={`/vendor/view-shop-banner/${param.id}`} />}
      {redirect && <Redirect push to="/vendor/shop-banners" />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    bannerDetails: state.banner.bannerDetails,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(ShopBannerForm);
